import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import { NeuButton, NeuCard, NeuInput } from "../components/neu/Neu";
import { SignatureCanvas } from "../features/pay/SignatureCanvas";
import { confirmPayment, viewPaymentLink } from "../api/supplierPayables";

// صفحة عامة (بلا مصادقة) — يفتحها المورّد عبر رابط WhatsApp/Share.
export default function PayConfirmPage() {
  const { t } = useTranslation();
  const { token } = useParams();
  const [payable, setPayable] = useState(null);
  const [name, setName] = useState("");
  const [sig, setSig] = useState(null);
  const [agree, setAgree] = useState(false);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    viewPaymentLink(token).then(setPayable).catch((e) => setErr(e?.response?.data?.detail?.code || "invalid"));
  }, [token]);

  const submit = async () => {
    if (!sig) return toast.error("signature_required");
    if (!name.trim()) return toast.error("name_required");
    if (!agree) return toast.error("agreement_required");
    setBusy(true);
    try {
      const res = await confirmPayment(token, sig, name.trim());
      setDone(res);
    } catch (e) { toast.error(e?.response?.data?.detail?.code || "error"); }
    finally { setBusy(false); }
  };

  if (err) return <div className="mx-auto max-w-md p-6"><NeuCard className="p-6 text-center"><p className="text-lg font-black">{t("payConfirm.invalid")}</p></NeuCard></div>;
  if (!payable) return <div className="p-8 text-center">…</div>;
  if (done) return <div className="mx-auto max-w-md p-6"><NeuCard className="p-6 text-center"><p className="text-2xl font-black text-emerald-500">✓ {t("payConfirm.received")}</p><p className="mt-2 font-mono text-sm">{done.ref_number}</p></NeuCard></div>;

  return (
    <div className="mx-auto max-w-lg space-y-4 p-4">
      <NeuCard className="p-5" data-testid="pay-details">
        <p className="text-xs font-bold text-muted-foreground">{t("payConfirm.supplierPayment")}</p>
        <p className="mt-1 num font-mono text-lg font-black">{payable.ref_number}</p>
        <div className="mt-3 grid grid-cols-2 gap-3 text-sm">
          <div><p className="text-muted-foreground text-xs">{t("payConfirm.amount")}</p><p className="num font-mono font-black">{payable.amount} {payable.currency}</p></div>
          <div><p className="text-muted-foreground text-xs">{t("payConfirm.dueDate")}</p><p className="num font-mono font-bold" dir="ltr">{payable.due_date}</p></div>
          <div className="col-span-2"><p className="text-muted-foreground text-xs">{t("payConfirm.installment")}</p><p className="font-bold">{payable.installment_label || `#${payable.installment_number}`}</p></div>
        </div>
      </NeuCard>
      <NeuCard className="p-5 space-y-3">
        <NeuInput data-testid="signer-name" placeholder={t("payConfirm.signerName")} value={name} onChange={(e) => setName(e.target.value)} />
        <div>
          <p className="mb-1 text-xs font-bold text-muted-foreground">{t("payConfirm.signHint")}</p>
          <SignatureCanvas onChange={setSig} />
        </div>
        <label className="flex items-center gap-2 text-sm">
          <input type="checkbox" data-testid="agree" checked={agree} onChange={(e) => setAgree(e.target.checked)} />
          {t("payConfirm.agree")}
        </label>
        <NeuButton onClick={submit} disabled={busy} data-testid="confirm-btn">{t("payConfirm.confirm")}</NeuButton>
      </NeuCard>
    </div>
  );
}
